import React, { useState } from 'react';
import { toast } from 'react-toastify';
import {
  Col, Row, Form, Button,
} from 'react-bootstrap';
import { post } from '../../../utils/HttpRequests';
import './UnblockSuperAdmin.css';

let checkValidMobileNumber = true;
let checkValidEmailId = true;
const errorCode_email_toast = 'Please enter a valid email id';
const errorCode_mobileNumber_toast = 'Please enter a valid mobile number';
const errorcode_empty_data = 'Please enter the fields';

function UnblockSuperAdmin() {
  const [data, setData] = useState({
    mobileNumber: [''],
    emailId: [''],
  });
  const { mobileNumber, emailId } = data;
  const ValidateEmail = (email) => {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  };
  const ValidateMobileNumber = (mobileNo) => {
    if (mobileNo.match(/^\d{10}$/)) {
      return true;
    }
    return false;
  };
  const changeHandler = (e) => {
    if (e.target.name === 'emailId' && e.target.value) {
      checkValidEmailId = ValidateEmail(e.target.value);
    }
    if (e.target.name === 'mobileNumber' && e.target.value) {
      checkValidMobileNumber = ValidateMobileNumber(e.target.value);
    }
    setData({ ...data, [e.target.name]: [e.target.value] });
  };
  const notifyError = (errorcode) => toast.error(errorcode,
    {
      position: toast.POSITION.TOP_RIGHT,
      id: 'toastPosition',
    });
  const notifySuccess = (msg) => toast.success(msg,
    { position: toast.POSITION.TOP_RIGHT });
  function refreshData() {
    const newData = {
      mobileNumber: [''],
      emailId: [''],
    };
    setData(newData);
  }
  const triggerAPI = async (inputData) => {
    post('admin/console/unblock-super-admin-account',
      {
        mobile_no: inputData.mobileNumber[0],
        email_id: inputData.emailId[0],
      })
      .then((res) => {
        notifySuccess(res.data.response.msg);
        refreshData();
      })
      .catch((err) => {
        notifyError(err.response.data.error.reason);
        refreshData();
      });
  };
  const submitHandler = (e) => {
    e.preventDefault();
    if (data.emailId[0] === '' && data.mobileNumber[0] === '') {
      notifyError(errorcode_empty_data);
    }
    if (!checkValidEmailId && data.emailId[0] !== '') {
      notifyError(errorCode_email_toast);
    }
    if (!checkValidMobileNumber && data.mobileNumber[0] !== '') {
      notifyError(errorCode_mobileNumber_toast);
    }
    if ((checkValidEmailId || data.emailId[0] === '')
            && (checkValidMobileNumber || data.mobileNumber[0] === '')
            && (data.emailId[0] !== '' || data.mobileNumber[0] !== '')) {
      triggerAPI(data);
    }
  };
  return (
    <div>
      <Row>
        <Col sm={4} />
        <Col sm={4}>
          <div className="container" id="container">
            <h2 id="fontSize">Unblock Super Admin</h2>
            <form id="form">
              <Row>
                <Form.Group>
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={changeHandler}
                    value={mobileNumber}
                    name="mobileNumber"
                    size="lg"
                  />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group>
                  <Form.Label>Email Id</Form.Label>
                  <Form.Control
                    type="email"
                    onChange={changeHandler}
                    value={emailId}
                    name="emailId"
                    size="lg"
                  />
                </Form.Group>
              </Row>
              <Row>
                <Button type="submit" onClick={submitHandler} id="fontSize20px">
                  Unblock
                </Button>
              </Row>
            </form>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default UnblockSuperAdmin;
